// View Keys
export default {
  alertsTabView_Profiles: "Perfiles",
  alertsTabView_Alert: "Alertas",
  inboxTabView_Inbox: "bandeja de entrada",
  alersTabView_forGps:"Para dispositivos GPS",
  alersTabView_forCameras:"Para Camaras"
};
